import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import ReceiptSearch from "../components/ReceiptSearch";
import ReceiptTable from "../components/ReceiptTable";
import Paper from "@mui/material/Paper";

const ReceiptsView = () => {
  const [receiptDatas, setReceiptDatas] = useState(null);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);

  const updateData = (data, count) => {
    setPageCount(count);
    setReceiptDatas(data);
  };

  const getPage = (p) => setPage(p);

  return (
    <Paper>
      <Grid container spacing={4} sx={{ p: 4 }}>
        <Grid md={12}>
          <ReceiptSearch
            page={page}
            rowCount={15}
            updateReceiptData={updateData}
          />
        </Grid>
        <Grid md={12}>
          <ReceiptTable
            data={receiptDatas}
            getPage={getPage}
            pageCount={pageCount}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ReceiptsView;
